module.exports = __webpack_public_path__ + "img/mediaportal_search.6e5dae06.jpg";